import { render, staticRenderFns } from "./THREEJS.vue?vue&type=template&id=4b4af327&scoped=true"
import script from "./THREEJS.vue?vue&type=script&lang=js"
export * from "./THREEJS.vue?vue&type=script&lang=js"
import style0 from "./THREEJS.vue?vue&type=style&index=0&id=4b4af327&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b4af327",
  null
  
)

export default component.exports